
import { FC } from 'react';
import { HighlightWordProps } from './types';

export const HighlightedCaption: FC<HighlightWordProps> = ({
  text,
  isHighlighted,
  highlightColor,
}) => (
  <span
    style={{
      display: "inline-block",
      backgroundColor: isHighlighted ? highlightColor : "transparent",
      padding: "0 5px",
      borderRadius: "20px",
    }}
  >
    {text}
  </span>
);